<template>
  <!--просто класс-->
  <div
    v-if="block.id === 1"
    class="su-skills-block su-skills-block--1"
  >
    <div class="su-skills-block__side">
      <h3>{{ block.title }}</h3>
      <h6>полноценная альтернатива обычной школе, только онлайн</h6>
      <div class="su-skills-block__cheaps">
        <span>аттестат гос. образца</span>
        <span>онлайн-аттестация</span>
        <span>мини-группы до 15 чел.</span>
        <span>детский психолог</span>
        <span>персональный куратор</span>
        <span>помощь с ДЗ</span>
        <span>поддержка 24/7</span>
        <span>и многое другое</span>
      </div>
      <button
        class="m-btn"
        @click="$emit('openModal')"
      >
        записаться в класс
      </button>
    </div>
    <div class="su-skills-block__side">
      <h4>
        <span>получите</span> аттестат гос.&nbsp;образца,
        <span>занимаясь по&nbsp;российскому стандарту образования</span> ФГОС&nbsp;и&nbsp;ФООП
      </h4>
    </div>
  </div>

  <!--it класс-->
  <div
    v-else-if="block.id === 2"
    :class="[`su-skills-block su-skills-block--2`, {
      'su-skills-block--show': showMore,
    }]"
  >
    <div
      v-if="suMobile"
      class="m-btn su-skills-block__more"
      @click="showMore = !showMore"
    >
      <img
        v-show="!showMore"
        src="/v2/school-university/skills/more.svg"
        alt="?"
        loading="lazy"
      >
      <img
        v-show="showMore"
        src="/v2/school-university/skills/close.svg"
        alt="x"
        loading="lazy"
      >
    </div>

    <div class="su-skills-block__side">
      <h3>{{ block.title }}</h3>
      <h6 v-if="suMobile ? !showMore : true">
        <span>все&nbsp;как&nbsp;в&nbsp;простом классе,</span>
        но&nbsp;с&nbsp;упором на&nbsp;профиль
      </h6>
      <div
        v-if="suMobile ? !showMore : true"
        class="su-skills-block__cheaps"
      >
        <span>углубленная информатика</span>
        <span>высшая математика</span>
        <span>HTML и CSS</span>
        <span>статистика и аналитика</span>
        <span>Java разработка</span>
        <span>Python для анализа данных</span>
        <span>IT митапы</span>
        <span>и многое другое</span>
      </div>
      <button
        class="m-btn"
        @click="$emit('openModal')"
      >
        записаться в класс
      </button>
    </div>
    <div class="su-skills-block__side">
      <h4>
        <span>готовим  более чем к</span><br>
        64 специальностям <span>в вузах</span>
      </h4>
      <p>
        в&nbsp;IT классе ученики изучают Java Script, HTML5, C++ и другие языки программирования
        с&nbsp;целью поступления на&nbsp;самое востребованное в&nbsp;России направление
      </p>

      <div
        v-if="suMobile ? showMore : true"
        class="su-skills-block__specialties"
      >
        <span>64+</span>
        <span>IT-менеджмент</span>
        <span>python-разработчик</span>
        <span>веб-разработчик</span>
        <span>Data Mining</span>
        <span>C++-разработчик</span>
        <span>AI-инженер</span>
        <span>тестирование и DevOps</span>
        <span>fullstack-разработчик</span>
        <span>Data Science</span>
      </div>
    </div>
  </div>

  <!--кибер класс-->
  <div
    v-else-if="block.id === 3"
    :class="[`su-skills-block su-skills-block--3`, {
      'su-skills-block--show': showMore,
    }]"
  >
    <div
      v-if="suMobile"
      class="m-btn su-skills-block__more"
      @click="showMore = !showMore"
    >
      <img
        v-show="!showMore"
        src="/v2/school-university/skills/more.svg"
        alt="?"
        loading="lazy"
      >
      <img
        v-show="showMore"
        src="/v2/school-university/skills/close.svg"
        alt="x"
        loading="lazy"
      >
    </div>

    <div class="su-skills-block__side">
      <h3>{{ block.title }}</h3>
      <h6 v-if="suMobile ? !showMore : true">
        <span>все&nbsp;как&nbsp;в&nbsp;простом классе,</span>
        но&nbsp;с&nbsp;упором на&nbsp;профиль
      </h6>
      <div
        v-if="suMobile ? !showMore : true"
        class="su-skills-block__cheaps"
      >
        <span>уроки в метавселенной minecraft</span>
        <span>изучение языков программирования</span>
        <span>известные киберспортсмены и it-компании</span>
        <span>fast cup турниры</span>
        <span>киберспортивные турниры </span>
        <span>и многое другое</span>
      </div>
      <button
        class="m-btn"
        @click="$emit('openModal')"
      >
        записаться в класс
      </button>
    </div>
    <div class="su-skills-block__side">
      <h4>
        <span>готовим  более чем к</span><br>
        44 специальностям <span>в вузах</span>
      </h4>
      <p>
        в кибер-классе изучают основы программирования, геймдизайн, веб‑разработку,
        создание интерфейсов, кибербезопасность и&nbsp;другие IT-направления
      </p>

      <div
        v-if="suMobile ? showMore : true"
        class="su-skills-block__specialties"
      >
        <span>44+</span>
        <span>белый хакер</span>
        <span>геймдизайнер</span>
        <span>data mining</span>
        <span>Data Mining</span>
        <span>frontend-разработчик</span>
        <span>AI-инженер</span>
        <span>ai и bigdata</span>
        <span>fullstack-разработчик</span>
        <span>разработка игр</span>
      </div>
    </div>
  </div>

  <!--бизнес класс-->
  <div
    v-else-if="block.id === 4"
    :class="[`su-skills-block su-skills-block--4`, {
      'su-skills-block--show': showMore,
    }]"
  >
    <div
      v-if="suMobile"
      class="m-btn su-skills-block__more"
      @click="showMore = !showMore"
    >
      <img
        v-show="!showMore"
        src="/v2/school-university/skills/more.svg"
        alt="?"
        loading="lazy"
      >
      <img
        v-show="showMore"
        src="/v2/school-university/skills/close.svg"
        alt="x"
        loading="lazy"
      >
    </div>

    <div class="su-skills-block__side">
      <h3>{{ block.title }}</h3>
      <h6 v-if="suMobile ? !showMore : true">
        <span>все&nbsp;как&nbsp;в&nbsp;простом классе,</span>
        но&nbsp;с&nbsp;упором на&nbsp;профиль
      </h6>
      <div
        v-if="suMobile ? !showMore : true"
        class="su-skills-block__cheaps"
      >
        <span>презентация проектов</span>
        <span>расчет unit-экономики</span>
        <span>подбор персонала</span>
        <span>soft skills</span>
        <span>бизнес модели</span>
        <span>стратегический менеджмент</span>
        <span>антикризисное управление</span>
        <span>исследование рынка</span>
        <span>и многое другое</span>
      </div>
      <button
        class="m-btn"
        @click="$emit('openModal')"
      >
        записаться в класс
      </button>
    </div>
    <div class="su-skills-block__side">
      <h4>
        <span>готовим  более чем к</span><br>
        92 специальностям <span>в вузах</span>
      </h4>
      <p>
        в бизнес классе учат составлять бизнес-планы, понимать ключевые финансовые
        и юридические вопросы, управлять развитием компании и вести конкурентную борьбу,
        а так же маркетингу и продажам
      </p>

      <div
        v-if="suMobile ? showMore : true"
        class="su-skills-block__specialties"
      >
        <span>92+</span>
        <span>предприниматель</span>
        <span>топ-менеджер</span>
        <span>директор по развитию</span>
        <span>управление бизнесом</span>
        <span>инвестор</span>
        <span>коучинг</span>
        <span>наставничество </span>
      </div>
    </div>
  </div>

  <!--digital класс-->
  <div
    v-else-if="block.id === 5"
    :class="[`su-skills-block su-skills-block--5`, {
      'su-skills-block--show': showMore,
    }]"
  >
    <div
      v-if="suMobile"
      class="m-btn su-skills-block__more"
      @click="showMore = !showMore"
    >
      <img
        v-show="!showMore"
        src="/v2/school-university/skills/more.svg"
        alt="?"
        loading="lazy"
      >
      <img
        v-show="showMore"
        src="/v2/school-university/skills/close.svg"
        alt="x"
        loading="lazy"
      >
    </div>

    <div class="su-skills-block__side">
      <h3>{{ block.title }}</h3>
      <h6 v-if="suMobile ? !showMore : true">
        <span>все&nbsp;как&nbsp;в&nbsp;простом классе,</span>
        но&nbsp;с&nbsp;упором на&nbsp;профиль
      </h6>
      <div
        v-if="suMobile ? !showMore : true"
        class="su-skills-block__cheaps"
      >
        <span>дизайн-проектирование</span>
        <span>изучение Figma</span>
        <span>Tilda и Zero-кодинг</span>
        <span>программы Adobe Creative Cloud</span>
        <span>3D-моделирование</span>
        <span>основы маркетинга</span>
        <span>бренд-менеджмент</span>
        <span>копирайтинг</span>
        <span>SMM</span>
        <span>SEO</span>
        <span>и многое другое</span>
      </div>
      <button
        class="m-btn"
        @click="$emit('openModal')"
      >
        записаться в класс
      </button>
    </div>
    <div class="su-skills-block__side">
      <h4>
        <span>готовим  более чем к</span><br>
        127 специальностям <span>в вузах</span>
      </h4>
      <p>
        digital-класс готовит со школы специалистов самых востребованных
        профессий маркетинга, дизайна и PR
      </p>

      <div
        v-if="suMobile ? showMore : true"
        class="su-skills-block__specialties"
      >
        <span>127+</span>
        <span>UX/UI дизайнер</span>
        <span>графический дизайнер</span>
        <span>SEO-специалист</span>
        <span>таргетолог</span>
        <span>SMM-маркетолог</span>
        <span>интернет-маркетолог</span>
        <span>бренд менеджер</span>
        <span>аналитик цифровой среды </span>
      </div>
    </div>
  </div>

  <!--медиа класс-->
  <div
    v-else-if="block.id === 6"
    :class="[`su-skills-block su-skills-block--6`, {
      'su-skills-block--show': showMore,
    }]"
  >
    <div
      v-if="suMobile"
      class="m-btn su-skills-block__more"
      @click="showMore = !showMore"
    >
      <img
        v-show="!showMore"
        src="/v2/school-university/skills/more.svg"
        alt="?"
        loading="lazy"
      >
      <img
        v-show="showMore"
        src="/v2/school-university/skills/close.svg"
        alt="x"
        loading="lazy"
      >
    </div>

    <div class="su-skills-block__side">
      <h3>{{ block.title }}</h3>
      <h6 v-if="suMobile ? !showMore : true">
        <span>все&nbsp;как&nbsp;в&nbsp;простом классе,</span>
        но&nbsp;с&nbsp;упором на&nbsp;профиль
      </h6>
      <div
        v-if="suMobile ? !showMore : true"
        class="su-skills-block__cheaps"
      >
        <span>программы Adobe Creative Cloud</span>
        <span>основы мультипликации</span>
        <span>компьютерная графика</span>
        <span>сценарное искусство</span>
        <span>искусство востока</span>
        <span>моделинг</span>
        <span>журналистика</span>
        <span>и многое другое</span>
      </div>
      <button
        class="m-btn"
        @click="$emit('openModal')"
      >
        записаться в класс
      </button>
    </div>
    <div class="su-skills-block__side">
      <h4>
        <span>готовим  более чем к</span><br>
        51 специальностям <span>в вузах</span>
      </h4>
      <p>
        медиа класс создан на базе творческих факультетов вуза, которые сотрудничают
        с Союзмультфильм, МХАТ, Союз журналистов РФ, НТВ и ТВЦ
      </p>

      <div
        v-if="suMobile ? showMore : true"
        class="su-skills-block__specialties"
      >
        <span>127+</span>
        <span>художник анимации</span>
        <span>артист кино и театра</span>
        <span>motion-дизайнер</span>
        <span>кинооператор</span>
        <span>искусствовед</span>
        <span>продюсер кино и тв</span>
        <span>event менеджер </span>
      </div>
    </div>
  </div>

  <!--мед. класс-->
  <div
    v-else-if="block.id === 7"
    :class="[`su-skills-block su-skills-block--7`, {
      'su-skills-block--show': showMore,
    }]"
  >
    <div
      v-if="suMobile"
      class="m-btn su-skills-block__more"
      @click="showMore = !showMore"
    >
      <img
        v-show="!showMore"
        src="/v2/school-university/skills/more.svg"
        alt="?"
        loading="lazy"
      >
      <img
        v-show="showMore"
        src="/v2/school-university/skills/close.svg"
        alt="x"
        loading="lazy"
      >
    </div>

    <div class="su-skills-block__side">
      <h3>{{ block.title }}</h3>
      <h6 v-if="suMobile ? !showMore : true">
        <span>все&nbsp;как&nbsp;в&nbsp;простом классе,</span>
        но&nbsp;с&nbsp;упором на&nbsp;профиль
      </h6>
      <div
        v-if="suMobile ? !showMore : true"
        class="su-skills-block__cheaps"
      >
        <span>анатомия человека</span>
        <span>микробиология</span>
        <span>травматология</span>
        <span>биоэтика</span>
        <span>биохимия</span>
        <span>иммунология</span>
        <span>фармакология</span>
        <span>ортопедия и ортодонтия</span>
        <span>и многое другое</span>
      </div>
      <button
        class="m-btn"
        @click="$emit('openModal')"
      >
        записаться в класс
      </button>
    </div>
    <div class="su-skills-block__side">
      <h4>
        <span>готовим  более чем к</span><br>
        12 специальностям <span>в вузах</span>
      </h4>
      <p>
        медицинский класс для&nbsp;тех, кто&nbsp;хочет примерить на&nbsp;себе самую востребованную
        профессию врача и&nbsp;принять&nbsp;взвешенное решение о&nbsp;поступлении
        в&nbsp;профильный&nbsp;вуз
      </p>

      <div
        v-if="suMobile ? showMore : true"
        class="su-skills-block__specialties"
      >
        <span>12+</span>
        <span>стоматолог-гигиенист</span>
        <span>врач-стоматолог</span>
        <span>фармацевт</span>
        <span>фельдшер</span>
        <span>терапевт</span>
        <span>кардиохирург</span>
        <span>фармаколог-исследователь</span>
        <span>провизор</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SuSkillsBlock',
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showMore: false,
  }),
  computed: {
    ...mapGetters({
      windowSize: 'getWindowSize',
    }),
    suMobile() {
      return this.windowSize < 768;
    },
  },
};
</script>

<style scoped lang="scss">

.su-skills-block {
  height: calc(var(--scale) * 720);
  padding: 1rem 2.5rem 2.5rem;
  display: flex;
  justify-content: space-between;

  border-radius: 60px;
  background-size: cover;
  background-position: center;

  @include media-down($size-tablet) {
    height: calc(var(--scale) * 512);
    padding: 2rem 1.6rem 0.8rem;
    border-radius: 3.2rem;
  }

  @include media-down($size-mobile) {
    position: relative;
    height: calc(var(--scale) * 720);
    flex-direction: column;
  }

  &--show {
    justify-content: flex-start;
    gap: 1.2rem;
  }

  .su-skills-block__side {
    width: calc(var(--scale) * 715);
    display: flex;
    flex-direction: column;

    @include media-down($size-tablet) {
      width: calc(var(--scale) * 340);
    }

    @include media-down($size-mobile) {
      width: 100%;
    }

    &:first-of-type {
      align-items: flex-start;
    }

    &:last-of-type {
      align-items: flex-end;

      @include media-down($size-mobile) {
        align-items: flex-start;
        padding-bottom: calc(var(--scale) * 112);
      }
    }
  }

  h3 {
    margin-bottom: 1.5rem;
    font-weight: 500;
    font-size: 7rem;
    line-height: 90%;
    letter-spacing: -0.06em;
    color: #FFFFFF;
    white-space: nowrap;

    @include media-down($size-tablet) {
      font-size: 4.4rem;
      margin-bottom: 0;
    }
  }

  h6 {
    margin-bottom: 1rem;

    font-style: normal;
    font-weight: 500;
    font-size: 3rem;
    line-height: 110%;
    letter-spacing: -0.02em;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      margin-top: 1.2rem;
      font-size: 2rem;
    }

    @include media-down($size-mobile) {
      margin-bottom: 1.2rem;
    }

    span {
      color: rgba(#FFFFFF, 0.6);
    }
  }

  .su-skills-block__cheaps {
    display: flex;
    flex-wrap: wrap;
    gap: 7px 4px;

    @include media-down($size-tablet) {
      gap: 0.2rem;
    }

    span {
      padding: calc(var(--scale) * 9) calc(var(--scale) * 18);

      background-color: rgba(#ffffff, 0.01);
      border: 1px solid rgba(#ffffff, 0.5);
      backdrop-filter: blur(5px);
      border-radius: 2.5rem;

      font-style: normal;
      font-weight: 500;
      font-size: 1rem;
      line-height: 130%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        padding: 0.6rem 1.1rem;
        font-size: 1.4rem;
      }

      &:last-child {
        background-color: rgba(#ffffff, 0.3);

        @include media-down($size-tablet) {
          border: none;
          padding: 0.7rem 1.2rem;
        }
      }
    }
  }

  button {
    margin-top: auto;

    padding: 2.75rem 3rem;
    background-color: #FFFFFF;
    border-radius: 2.5rem;

    font-weight: 500;
    font-size: 2rem;
    line-height: 110%;
    color: #5237E6;

    @include media-down($size-tablet) {
      width: 72rem;
      margin-left: calc(-1 * 0.8rem);
      padding: 3rem;
      box-shadow: 1rem 1rem 5rem rgba(7, 21, 57, 0.1), 0.4rem 0.4rem 2rem rgba(7, 21, 57, 0.05);
      font-size: 1.8rem;
    }

    @include media-down($size-mobile) {
      width: calc(100% - 1.6rem);
      position: absolute;
      bottom: 0.8rem;
      left: 1.6rem;
    }
  }

  h4 {
    margin-bottom: 1.25rem;

    font-weight: 500;
    font-size: 3rem;
    line-height: 110%;
    text-align: right;
    letter-spacing: -0.02em;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      font-size: 2rem;
    }

    span {
      color: rgba(#FFFFFF, 0.6);
    }

    @include media-down($size-mobile) {
      text-align: left;
    }
  }

  p {
    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 120%;
    text-align: right;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      font-size: 1.8rem;
      line-height: 110%;
    }

    @include media-down($size-mobile) {
      text-align: left;
    }
  }

  .su-skills-block__specialties {
    margin-top: auto;
    width: calc(var(--scale) * 770);

    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.75rem;

    @include media-down($size-tablet) {
      width: 100%;
      gap: 0.2rem;
      margin-bottom: 10rem;
    }

    @include media-down($size-mobile) {
      justify-content: flex-start;
      margin-top: 2rem;
    }

    span {
      padding: 1rem 1.25rem;

      background-color: rgba(#000000, 0.01);
      border: 1px solid #FFFFFF;
      backdrop-filter: blur(5px);
      border-radius: 100px;

      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        padding: 0.6em 1.1rem;
        font-size: 1.4rem;
        line-height: 130%;
      }

      &:first-child {
        background-color: #FFFFFF;
        color: #02120F;
      }
    }
  }
}

.su-skills-block__more {
  position: absolute;
  top: 2.2rem;
  right: 1.6rem;
  width: 3.3rem;
  height: 3.3rem;
  background-color: #ffffff;
  border-radius: 50%;
  display: grid;
  place-content: center;
  transition: none;
}

.su-skills-block--1 {
  background-color: #7152f1;
  background-image: url("/v2/school-university/skills/1.webp");

  @include media-down($size-tablet) {
    background-image: url("/v2/school-university/skills/1-tablet.webp");
  }

  @include media-down($size-mobile) {
    background-image: url("/v2/school-university/skills/1-mobile.webp");
  }

  button {
    color: #5237E6;

    @media (hover: hover) {
      &:hover {
        background-color: #E6CEFF;
      }
    }
  }
}

.su-skills-block--2 {
  background-color: #0e5ea6;
  background-image: url("/v2/school-university/skills/2.webp");

  @include media-down($size-tablet) {
    background-image: url("/v2/school-university/skills/2-tablet.webp");
  }

  @include media-down($size-mobile) {
    background-image: url("/v2/school-university/skills/2-mobile.webp");

    &.su-skills-block--show {
      background-image: url("/v2/school-university/skills/2-mobile-more.webp");
    }

    .su-skills-block__more img {
      filter: invert(20%) sepia(97%) saturate(1113%) hue-rotate(192deg) brightness(88%) contrast(103%);
    }
  }

  button {
    color: #0A4183;

    @media (hover: hover) {
      &:hover {
        background-color: #CEF9FF;
      }
    }
  }
}

.su-skills-block--3 {
  background-color: #057663;
  background-image: url("/v2/school-university/skills/3.webp");

  @include media-down($size-tablet) {
    background-image: url("/v2/school-university/skills/3-tablet.webp");
  }

  @include media-down($size-mobile) {
    background-image: url("/v2/school-university/skills/3-mobile.webp");

    &.su-skills-block--show {
      background-image: url("/v2/school-university/skills/3-mobile-more.webp");
    }

    .su-skills-block__more img {
      filter: invert(22%) sepia(19%) saturate(2570%) hue-rotate(124deg) brightness(99%) contrast(97%);
    }
  }

  button {
    color: #045140;

    @media (hover: hover) {
      &:hover {
        background-color: #D1FAD8;
      }
    }
  }
}

.su-skills-block--4 {
  background-color: #141414;
  background-image: url("/v2/school-university/skills/4.webp");

  @include media-down($size-tablet) {
    background-image: url("/v2/school-university/skills/4-tablet.webp");
  }

  @include media-down($size-mobile) {
    background-image: url("/v2/school-university/skills/4-mobile.webp");

    &.su-skills-block--show {
      background-image: url("/v2/school-university/skills/4-mobile-more.webp");
    }

    .su-skills-block__more img {
      filter: invert(6%) sepia(11%) saturate(2732%) hue-rotate(118deg) brightness(97%) contrast(100%);
    }
  }

  button {
    color: #02120F;

    @media (hover: hover) {
      &:hover {
        background-color: #FFF0D1;
      }
    }
  }
}

.su-skills-block--5 {
  background-color: #fe7920;
  background-image: url("/v2/school-university/skills/5.webp");

  @include media-down($size-tablet) {
    background-image: url("/v2/school-university/skills/5-tablet.webp");
  }

  @include media-down($size-mobile) {
    background-image: url("/v2/school-university/skills/5-mobile.webp");

    &.su-skills-block--show {
      background-image: url("/v2/school-university/skills/5-mobile-more.webp");
    }

    .su-skills-block__more img {
      filter: invert(46%) sepia(66%) saturate(4429%) hue-rotate(350deg) brightness(101%) contrast(101%);
    }
  }

  button {
    color: #FF5319;

    @media (hover: hover) {
      &:hover {
        background-color: #FFF0D1;
      }
    }
  }
}

.su-skills-block--6 {
  background-color: #07865a;
  background-image: url("/v2/school-university/skills/6.webp");

  @include media-down($size-tablet) {
    background-image: url("/v2/school-university/skills/6-tablet.webp");
  }

  @include media-down($size-mobile) {
    background-image: url("/v2/school-university/skills/6-mobile.webp");

    &.su-skills-block--show {
      background-image: url("/v2/school-university/skills/6-mobile-more.webp");
    }

    .su-skills-block__more img {
      filter: invert(21%) sepia(87%) saturate(1139%) hue-rotate(130deg) brightness(99%) contrast(101%);
    }
  }

  button {
    color: #006440;

    @media (hover: hover) {
      &:hover {
        background-color: #D1FAD8;
      }
    }
  }
}

.su-skills-block--7 {
  background-color: #b53b96;
  background-image: url("/v2/school-university/skills/7.webp");

  @include media-down($size-tablet) {
    background-image: url("/v2/school-university/skills/7-tablet.webp");
  }

  @include media-down($size-mobile) {
    background-image: url("/v2/school-university/skills/7-mobile.webp");

    &.su-skills-block--show {
      background-image: url("/v2/school-university/skills/7-mobile-more.webp");
    }

    .su-skills-block__more img {
      filter: invert(16%) sepia(67%) saturate(3225%) hue-rotate(298deg) brightness(87%) contrast(97%);
    }
  }

  button {
    color: #8D176C;

    @media (hover: hover) {
      &:hover {
        background-color: #FFCEE2;
      }
    }
  }
}

</style>
